import React, { Fragment } from 'react'

const PhraseExtractIupp = () => {
  return (
    <Fragment>
      Se você tem pontos a expirar neste mês, não se preocupe: eles seguirão válidos para você usar até 31/07/21.
    </Fragment>
  )
}

export default PhraseExtractIupp



// WEBPACK FOOTER //
// ./src/Participant/Extract/Details/PhraseExtractIupp.js